export enum ProductImageEventAction {
    DISPLAY = 'display',
    NAVIGATION = 'navigation',
    ZOOM = 'zoom',
}

export enum ProductImageEventLabel {
    OPEN = 'open',
    CLOSE = 'close'
}